import GroupSourceTypeLabel from './GroupSourceTypeLabel';

export default GroupSourceTypeLabel;
